<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Eğitim</label>
            <v-select-list :options="educations" placeholder="Eğitim"  v-model="education" label="Name"></v-select-list>
        </div>
        <!-- <div class="col-12 mb-1">
            <label class="form-label">Başlangıç Zamanı</label>
            <v-date-picker type="datetime" placeholder="Başlangıç Zamanı"  v-model="value.StartDateTime"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Bitiş Zamanı</label>
            <v-date-picker type="datetime" placeholder="Bitiş Zamanı" v-model="value.EndDateTime"></v-date-picker>
        </div> -->

        <div class="col-12 mb-1">
            <div class="d-flex justify-content-between align-items-center">
                <label class="form-label fw-bolder mb-0 mr-1">Eğitim Oturumları</label>
                <button type="button" class="btn btn-primary btn-sm" v-on:click="$emit('add-session')">
                    <feather-icon icon="PlusIcon" class="mr-25"/>Yeni Oturum Ekle
                </button>
            </div>
            <hr class="mt-1">

            <div v-if="!value.Sessions || !value.Sessions.length" class="text-center text-muted p-1 border rounded">
                Henüz bir oturum eklenmedi.
            </div>

            <div v-for="(session, index) in value.Sessions" :key="index" class="row align-items-center mb-1">
                <div class="col-5">
                    <v-date-picker placeholder="Başlangıç Zamanı" v-model="session.StartDateTime"  type="datetime"> </v-date-picker>
                </div>
                <div class="col-5">
                    <v-date-picker placeholder="Bitiş Zamanı"  v-model="session.EndDateTime"  type="datetime"> </v-date-picker>
                </div>
                <div class="col-2 text-right">
                    <button type="button" class="btn btn-danger btn-sm" v-on:click="$emit('remove-session', index)"> <FeatherIcon icon="Trash2Icon" /> </button>
                </div>
            </div>
            <div class="col-12">
                <span v-if="parseFloat(totalHours) > 0" class="badge badge-success"> <feather-icon icon="ClockIcon" size="14" class="mr-50" /> Toplam: {{ totalHours }} saat </span>
            </div>
            <hr class="mt-1">
        </div>

        <!-- <div class="col-12 mb-1">
            <label class="form-label">Geçerlilik Başlangıç Tarihi</label>
            <v-date-picker placeholder="Geçerlilik Başlangıç Tarihi" v-on:input="setEnd" v-model="value.ValidityStartDate"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Geçerlilik Bitiş Tarihi</label>
            <v-date-picker disabled placeholder="Geçerlilik Bitiş Tarihi" v-model="session.StartDateTime"></v-date-picker>
        </div> -->
        <div class="col-12">
            <v-file-uploader :accept="['xlsx','png','jpg','doc','docx','xls','pdf','jpeg','txt']" :value="value" value-parameter="File"></v-file-uploader>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import OHSEducationApi from '@/api/ohs-education'
import moment from 'moment'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default{
    components:{
        VFileUploader
    },
    props:{
        value:Object,
        totalHours: {
            type: [Number, String],
            default: 0
        }
    },
    data(){
        return {
            educations:[]
        }
    },
    mounted(){
        this.getEducations()
    },
    methods:{
        getEducations(){
            OHSEducationApi.List().then(res => {
                this.educations = res.data.Data || []
            })
        },
        // setEnd(){
        //     if(this.education && this.education?.RenewalPeriodYears && this.value.ValidityStartDate){
        //         this.value.ValidityEndDate = moment(this.value.ValidityStartDate,'YYYY-MM-DD').add(this.education?.RenewalPeriodYears || 0, 'years').format('YYYY-MM-DD')
        //     }else this.value.ValidityEndDate = null
        // }
    },
    computed:{
        education:{
            get:function(){
                return this.educations.find(b=>b.Id==this.value.OHSEducationId)
            },
            set:function(value){
                this.value.OHSEducationId = value?.Id || null
            }
        }
    }
}
</script>